import { combineReducers } from 'redux'
import spinner from "./ui/spinner"
import bookings from "./ui/bookings"

export const uiReducer = combineReducers({
	spinner,
	bookings
})


// WEBPACK FOOTER //
// ./src/reducers/ui.js